import { actionCreatorFactory, Action, Success } from 'typescript-fsa'
import { AppMetaData } from '../api/types'
import { Language } from './types'
import { LanguageCode } from 'mytours-read-api-typescript'
import { ScannerItemType } from '../scanner/types'

const actionCreator = actionCreatorFactory('Settings')

// fired when user set the new app info
export interface ChangeAppInfoParams {
	id: string
	projectId: string
	token: string
}
export type ChangeAppInfoAction = Action<ChangeAppInfoParams>
export const changeAppInfo = actionCreator<ChangeAppInfoParams>('CHANGE_APP_INFO')

// triggers loading of App Meta data, either from disk or network
export const loadAppMetaData = actionCreator('LOAD_APP_META_DATA')

// meta data was successfully loaded from disk to be put onto redux store
export const loadedMetaDataComplete = actionCreator<AppMetaData>('LOADED_APP_META_DATA_COMPLETE')

// handles unpacking of initial assets to local storage
export const unpackInitialAssets = actionCreator<undefined>('UNPACK_INITIAL_ASSETS')

export const appLanguageSelected = actionCreator<Language>('APP_LANGUAGE_SELECTED')

// once initial rental mode has been initialised we set flag on redux so the TourBuddy screen is not shown on app start
export const setInitialisedRentalMode = actionCreator<boolean>('SET_INITIALISED_RENTAL_MODE')

export const enableLocationEvents = actionCreator<boolean>('ENABLE_LOCATION_EVENTS')

export const clearRentalToken = actionCreator('CLEAR_RENTAL_TOKEN')

export const screenTimeoutSelected = actionCreator<number | undefined>('SCREEN_TIMEOUT_SELECTED')

// action dispatched during processing the downloaded manifest
interface ManifestStateParams {
	event: 'processing' // started processing the manifest file - should also provide array of items to process
	| 'finished' // finished processing the manifest file
	| 'clear' // clear the manifest details from redux
	| 'languageComplete' // completed processing a single language
	items?: ProcessingManifestItem[]
	allLanguages?: LanguageCode[] // list of all languages to be processed
	completedLanguage?: LanguageCode // language that just finished being processed
}
export interface ProcessingManifestItem {
	itemId: number
	itemVersion: number
	language: string
	type: 'screen' | 'collection' | 'collectionItem' | 'media'
	state: 'processing' | 'success_downloaded' | 'success_existed' | 'failed'
}
export const updateProcessingManifestState = actionCreator<ManifestStateParams>('UPDATE_PROCESSING_MANIFEST_STATE')
// just updating a single item in the manifest (used to dispatch media item events of all types)
export const updateProcessingManifestStateItem = actionCreator<ProcessingManifestItem>('UPDATE_PROCESSING_MANIFEST_STATE_ITEM')

export interface LoadItemOnKeypadEntry {
	keypadNumber: number
	itemType: ScannerItemType
	itemId: number
}

export type LoadItemOnKeypadEntryParams = Action<LoadItemOnKeypadEntry>
type LoadItemOnKeypadEntrySuccess = Success<number, undefined>
export type LoadItemOnKeypadEntryResult = Action<LoadItemOnKeypadEntrySuccess>
export const loadItemOnKeypadEntry = actionCreator.async<LoadItemOnKeypadEntry, undefined, Error>('LOAD_ITEM_ON_KEYPAD_ENTRY')